





































































import Vue from 'vue'
import Component, {mixins} from 'vue-class-component';
import {Action, State} from 'vuex-class';
import Permission from '@/modules/authorization/model/Permission';
import {DateMixin} from '@/modules/core/date';
import {notify} from '@/modules/core/notification';
import {Prop} from 'vue-property-decorator';
import PermissionSelect from '@/modules/authorization/components/PermissionSelect.vue';

/**
 * Pantalla maestra que muestra el árbol con los permisos de usuario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {PermissionSelect},
})
export default class PermissionDetail extends mixins(DateMixin) {
    /**
     * Permiso actualmente seleccionado por el usuario
     */
    @State(state => state.authorization.permission)
    public permission: Permission

    /**
     * Editando permiso
     *
     * Indica si el usuario se encuentra editando o creando un permiso en
     * la pantalla del detalle
     */
    @State(state => state.authorization.editingPermission)
    public editingPermission: boolean

    /**
     * Reseta el nuevo permiso en edición
     */
    @Action('authorization/resetCurrentPermission')
    public resetCurrentPermission: () => void

    /**
     * Deshabilita los campos de texto
     */
    @Prop({type: Boolean, default: false})
    public disabled: boolean

    /**
     * Oculta los botones de acción de guardar
     */
    @Prop({type: Boolean, default: false})
    public hideActions: boolean

    public saving = false

    public get cardStyles () {
        return {
            height: `calc(100vh - ${ this.$vuetify.breakpoint.mdAndUp ? 9.85 : 6.40 }rem)`,
            overflow: 'auto',
        }
    }

    /**
     * Guarda lo cambios del permiso actualmente en edición
     */
    public async save () {
        this.saving = true
        await this.$store.dispatch('authorization/savePermission')
        notify(`El permiso ${this.permission.path} se ha guardado correctamente`)

        this.saving = false
    }

    /**
     * Indica si la edición del permiso se encuentra deshabilitada
     */
    public get isDisabled () {
        return this.disabled || !this.editingPermission || this.saving
    }
}
